import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import IAuthorizationData from "../../../core/src/server/data/IAuthorizationData";

import GameModel from "../../../core/src/model/GameModel";
import Utils from "../../../core/src/utils/Utils";
import ISpinData from "../../../core/src/server/data/ISpinData";
import { Math } from 'es6-shim';

export default class RefreshReelDataParser
    implements IBaseDataParser<ISpinData>
{
    check(data: any): boolean {
        return data?.data?.gameData?.lineLayout;
    }

    parse(data): ISpinData[] {
        let numberOfReels = data.data.gameData.reelToViewMap.length;
        let stops = data.data.gameData.reelStops;
        let layout = data.data.gameData.reelToViewMap;
        let offset = GameModel.gameConfig.reelExtraSymbols || 0;
        const reelSetIndex = 0;
        let syms = Array.from(
            new Array(numberOfReels),
            (reel, reelId) => {
                return Array.from(
                    new Array(layout[reelId].length),
                    (row, rowId) => {
                        let set = Utils.deepClone(
                            GameModel.gameConfig.reelSets[reelSetIndex][reelId]
                        );
                        let pos = stops[reelId];
                        let id = !isNaN(set[pos + rowId])
                            ? set[pos + rowId]
                            : set[Math.abs(set.length - pos - rowId)];
                        return id;
                    }
                );
            }
        );

        let reelSets = Utils.deepClone(GameModel.gameConfig.reelSets);
        const reelStopSymbols = new Map<number, number[][]>();
        reelStopSymbols.set(reelSetIndex, syms);
        const stopPositions = new Map<number, number[]>();
        stopPositions.set(reelSetIndex, stops);
        const result: ISpinData = {
            stopPositions,
            reelStopSymbols,
            reelFinalSymbols: reelStopSymbols,
            reelSets,
        };

        return [result];
    }
}
